export const buildViewAllHref = section => {
    try {
        const params = [];
        const s = section || {};
        if (Array.isArray(s.filters)) {
            for (const f of s.filters) {
                if (f && f.field && (f.value !== undefined && f.value !== null)) {
                    params.push(`${encodeURIComponent(f.field)}=${encodeURIComponent(String(f.value))}`);
                }
            }
        }
        if (s.sort) {
            params.push(`sort=${encodeURIComponent(s.sort)}`);
        }
        if (params.length === 0) return null;
        const qs = `?${params.join('&')}`;
        return `/shop/${qs}`;
    } catch (e) {
        return null;
    }
};